import React from "react";
import VoidApi_json_dataAuth from "./VoidApi_json_data/VoidApi_json_dataAuth";
import VoidApi_json_Transaction from "./VoidApi_json_data/VoidApi_json_Transaction";
function VoidApi() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>VOID API</h2>
              <hr />
            </section>

            {/*  JS Checkout flow video: strat */}
            {/*  JS Checkout flow video. end */}

            <p>The user can use this API to Void any transaction.</p>

            <u>
              <h5>Request URL :</h5>
            </u>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">URL</td>
                  <td>
                    <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/othersRedirection/initiateVoid">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/othersRedirection/initiateVoid
                    </a>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Method</td>
                  <td>POST</td>
                </tr>
                <tr>
                  <td className="table-color">Content-Type</td>
                  <td>Application-JSON </td>
                </tr>
              </tbody>
            </table>

            <h4>Response Parameters :</h4>

            <p>
              <span>&#123;</span>
              "status": "OK", "userMessage": "Void Initiated Succesfully",
              "responseDataType": "Txn_Response", "responseData": "&#123;
              \"ag_id\":\"6215f3b65aba8f48b9ad4324\",\"me_id\":\"65c
              c5a64d7dd9c638b165889\",\"ag_ref\":\"2058521712741597325\",\"currency\":\"AE
              D\",\"txn_date\":\"2024-04-10T14:13:14.453\",\"txn_time\":\"2024-04-
              10T14:13:14.453\",\"pg_ref\":\"0000VG\",\"status\":\"Voided\",\"res_code\":\
              "00000\",\"res_message\":\"Void Transaction processed
              Successfully\",\"amoun t\":\"100.00\"&#125;", "errorCode": null,
              "errorMessage": null, "sysErrorMessage": null
              <span>&#125;</span>
            </p>

            <h4>Screenshot for reference:</h4>

            <div className="img-void-div mb-3 mt-3">
              <img
                src="assets/images/pg-images/void_api_img.png"
                alt="voidlogo"
              />
            </div>

            <h4>Screenshot for reference:</h4>

            <div className="img-void-div mt-3">
              <img src="assets/images/pg-images/voidapi.png" alt="voidlogo" />
            </div>
          </div>
          <div class="col-md-4">
            <VoidApi_json_dataAuth />
            {/* <VoidApi_json_Transaction /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default VoidApi;
